import { render } from "./App.vue?vue&type=template&id=3d73ed62"
const script = {}

import "./App.vue?vue&type=style&index=0&id=3d73ed62&lang=css"

import exportComponent from "D:\\Git\\Tepparad\\Tepparad-benefit-newver\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__